module.exports = __webpack_public_path__ + "img/shirt1-unisex.95219567.svg";